import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/weddify_home/weddify_home/src/components/loader/AppLoader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/weddify_home/weddify_home/src/views/contact/AppContact.tsx");
